<template>
	<div class="main-containter"  id="top" v-title data-title="和华利盛">
		<FHeader :checkId="25"></FHeader>
		<FOtherBanner :name1="'业务领域'" :name2="'Business Area'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article :style="{height: (((tableData.length / 3) * 135)+400)+'px'}">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">业务领域</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;position: absolute;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">业务领域</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Business Area</div>
				</div>
				<div style="padding-top:30px;">
					<div>
						<div style="width: 68%;text-align: center;margin-left: 16%;font-size: 14px;margin-top: 20px;color: #333333;">国内长期从事不良资产业务的律师事务所之一。本部律师不仅在合同法、公司法、物权法等领域具有深厚的理论功底及丰富的实践经验，更长期服务于国内各大商业银行、资产管理公司、投资公司等知名金融机构，与资金方、资产方及通道方均有良好的合作关系。不良资产业务部律师深谙不良资产处置的行业特性。</div>
					</div>
					<section>
						<button @click="toDetail(item)" :style="{width:'30%','margin-right':((index+1)%3==0)?'0':'5%',height:'135px'}" class="btn btn-green btn-border-o" v-for="(item,index) in tableData" :key="index">
							<div style="float:left;font-size: 18px;font-weight: 100;color: #98273A;margin-top: 80px;">
								{{item.title}}
							</div>
							<div style="float:right;font-weight: 100;color: #98273A;font-size: 14px;margin-top: 84px;">
								more
							</div>
						</button>
					</section>
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"
	
	import {query} from "@/api/service";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				tableData: [],
				total:0
			}
		},
		mounted() {
			this.list()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/businessAreaDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			list() {
				let param = {
					title: '',
					channelId: null,
					page: 1,
					pageSize: 99999,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">
	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
button{cursor:pointer;}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}

</style>
